import React from "react";
import { Modal, Button, FormGroup, Input } from "reactstrap";

function AuthorSelection(props) {
  return (
    <Modal
      className="modal-dialog-centered modal-sm"
      isOpen={props.operationNewModal}
      toggle={() => props.toggleNewModal()}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => props.toggleNewModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        {/* {props.sub.errorMsg} */}
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={(e) => props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(7) !== -1
                  : false
              }
              value={7}
            >
              直播
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(8) !== -1
                  : false
              }
              value={8}
            >
              新聞報導
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(9) !== -1
                  : false
              }
              value={9}
            >
              專題訪談
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(162) !== -1
                  : false
              }
              value={162}
            >
              影片廣告
            </option>
          </Input>
        </FormGroup>

        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => props.toggleNewModal()}
          >
            取消
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => props.submitArticle()}
          >
            新建
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AuthorSelection;
